// Cape Fear Boat Lifts - Theme JS

(function() {
  // Mobile menu toggle
  const menuToggle = document.querySelector('.header__menu-toggle');
  const navList = document.querySelector('.header__nav-list');

  if (menuToggle && navList) {
    menuToggle.addEventListener('click', function() {
      navList.classList.toggle('is-open');
      const isOpen = navList.classList.contains('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });

    // Close menu on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header')) {
        navList.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Product page image gallery
  const mainImage = document.querySelector('.product-page__main-image');
  const thumbnails = document.querySelectorAll('.product-page__thumbnail');

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const newSrc = this.dataset.fullImage;
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
        thumbnails.forEach(t => t.classList.remove('product-page__thumbnail--active'));
        this.classList.add('product-page__thumbnail--active');
      }
    });
  });

  // Variant selector
  const variantSelect = document.querySelector('.product-page__variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.dataset.price;
      const priceEl = document.querySelector('.product-page__price');
      if (priceEl && price) {
        priceEl.textContent = price;
      }
    });
  }
})();
